<template>
    <div class="selector-container">
        <vs-row>
            <vs-checkbox
                v-model="filterByOnlyMine"
                name="filterByOnlyMine"
            >
                Mes savoir-faire uniquement
            </vs-checkbox>
        </vs-row>

        <vs-row class="mt-5">
            <span class="vs-col">
                Glissez-déposez les Savoir-faire que vous souhaitez ajouter :
            </span>
        </vs-row>

        <vs-row class="mt-5">
            <!-- Occupation skills left (not selected) -->
            <vs-col vs-w="5.5">
                <h5 class="text-primary font-bold">Savoir-faire disponibles : </h5>
                
                <div class="mt-3">
                    <div class="font-bold">Choisir une filière de savoir-faire</div>
                    <Multiselect
                        id="select-sector"
                        v-model="sector"
                        name="sector"
                        :options="sectors.data"
                        track-by="id"
                        label="title"
                        :multiple="false"
                        :group-select="false"
                        placeholder="Choisir..."
                        select-label=""
                        select-group-label=""
                        selected-label=""
                        deselect-label=""
                        deselect-group-label=""
                        :loading="sectors.loading"
                    />
                </div>

                <div class="mt-3">
                    <div class="font-bold">Choisir un métier centralisé</div>
                    <Multiselect
                        id="select-occupation"
                        v-model="occupation"
                        name="occupation"
                        :options="occupations.data"
                        track-by="id"
                        label="title"
                        :multiple="false"
                        :group-select="false"
                        placeholder="Choisir..."
                        select-label=""
                        select-group-label=""
                        selected-label=""
                        deselect-label=""
                        deselect-group-label=""
                        :loading="occupations.loading"
                        :disabled="filterByOnlyMine"
                    />
                </div>
                
                <div>
                    <template v-if="!sector && !occupation && !filterByOnlyMine && !Object.keys(occupationSkillsBySector).length">
                        <vs-alert class="mt-3" color="rgb(231, 154, 23)" active="true">
                            Veuillez sélectionner une filière pour afficher les savoir-faire disponibles.
                        </vs-alert>
                    </template>

                    <template v-else-if="(sector || filterByOnlyMine || occupation || search) && !hasOccupationSkills">
                        <vs-row class="mt-6 mb-4">
                            <vs-col vs-w="12">
                                <vs-input
                                    label="Recherche"
                                    v-model="search"
                                    name="JobFilterOccupationSkills"
                                    class="w-full"
                                    placeholder="Rechercher des savoir-faire..."
                                />
                            </vs-col>
                        </vs-row>

                        <vs-alert class="mt-3" color="rgb(21, 16, 255)" active="true">
                            Aucun savoir-faire correspondant aux critères.
                        </vs-alert>
                    </template>
                    <template v-else>
                        <!-- Search bar -->
                        <vs-row class="mt-6 mb-4">
                            <vs-col vs-w="12">
                                <vs-input
                                    label="Recherche"
                                    v-model="search"
                                    name="JobFilterOccupationSkills"
                                    class="w-full"
                                    placeholder="Rechercher des savoir-faire..."
                                />
                            </vs-col>
                        </vs-row>

                        <vs-list style="height: 250px; position: relative">
                            
                                <InfiniteScrollContainer :threshold="50" :onLoadMore="handleScrollLoadMore">
                                    <template v-for="(listItem, i) in occupationSkillsBySector">
                                        <vs-list-header
                                            color="primary"
                                            :title="i"
                                        ></vs-list-header>
                                        <draggable
                                            :value="listItem"
                                            group="skills"
                                            class="p-2 cursor-move"
                                        >
                                            <vs-list-item
                                                v-for="(item, j) in listItem"
                                                :key="i + '-' + j"
                                                :title="`${item.title}${item.establishment ? ' - ' + item.establishment.name : ''}`"
                                            />
                                        </draggable>
                                    </template>  
                                </InfiniteScrollContainer>

                        </vs-list>
                    </template>
                </div>
            </vs-col>

            <!-- Icons >> -->
            <template>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
                    <chevrons-right-icon
                        size="3x"
                        stroke="rgb(var(--vs-primary))"
                        class="custom-class"
                    />
                </vs-col>
            </template>

            <!-- Occupation skills right (selected) -->
            <vs-col vs-w="5.5">
                <h5 class="text-primary font-bold">Savoir-faire choisis : </h5>
                <vs-list class="scrollable_list">
                    <!-- <vs-list-header
                        :title="`Savoir-faire choisis`"
                        color="primary"
                    /> -->

                    <draggable
                        v-model="selected"
                        group="skills"
                        class="p-2 cursor-move scrollable_list"
                        @input="onSelectedChange"
                        :emptyInsertThreshold="250"
                        direction="horizontal"
                    >
                        <vs-list-item
                            v-for="(listItem, i) in selected"
                            :id="'occupationSkillSelected_' + listItem.id"
                            :key="listItem.id + '-' + i"
                            :title="listItem.title+(listItem.establishment? ' - '+listItem.establishment.name : '')"
                        />
                    </draggable>
                </vs-list>
            </vs-col>
            <!-- End Occupation skills right (selected) -->
        </vs-row>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import { ChevronsRightIcon } from "vue-feather-icons";
import { 
    loadOccupationSkills, 
    loadAdminOccupationSkills, 
    loadAdminOccupations,
    loadSectors
} from "@components/services/resources.js";


import Multiselect from 'vue-multiselect';
import InfiniteScrollContainer from "@components/form/InfiniteScrollContainer.vue";

export default {
    name: "OccupationSkillsSelector",
    components: {
        draggable,
        ChevronsRightIcon,
        Multiselect,
        InfiniteScrollContainer
    },
    props: {
        value: {
            type: Array,
            required: false
        },
        service: {
            type: [Object, null],
            required: false,
            default: null
        },
        gridSector: {
            type: [Object, null],
            required: false,
            default: null
        },
        filterBySector: {
            type: Boolean,
            required: false,
            default: false
        },
        filterByUserRelated: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {

        return {
            log: console.log,
            occSkills: {
                data: [],
                loading: false
            },
            availableOccSkills: {
                data: [],
                loading: false
            },
            sectors: {
                data: [],
                loading: false
            },
            establishments: {
                data: [],
                loading: false
            },
            occupations: {
                data: [],
                loading: false
            },
            selected: [],
            search: null,
            sector: null,
            occupation: null,
            filterByOnlyMine: null,
            page: 1,
            lastPage: 1,
        };
    },
    async created() {

        this.$vs.loading();
        await Promise.all([
            this.fetchEstablishments(),
            this.fetchSectors(),
            this.fetchAdminOccupations()
        ]);
        this.$vs.loading.close();

        console.log('Grid sector', this.gridSector)
        if (this.gridSector) this.sector = this.gridSector

        if (this.value) {
            this.selected = this.value.slice().sort((a, b) => {
                return a.pivot.order - b.pivot.order
            });

            this.selected.map((el, i) => {
                el.order = i;
                return el;
            })
        }

        // Savoir faire par défaut depuis ID dans l'URL
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('os') || searchParams.has('aos')) {
            
            const osIds = searchParams.has('os') ? searchParams.get('os').split(',') : []
            const aosIds = searchParams.has('aos') ? searchParams.get('aos').split(',') : []

            this.fetchOccSkills(null, osIds, aosIds).then(() => {

                osIds.forEach(id => {
                    this.selected.push(this.occSkills.data.find(os => os.id == id && os.resource == 'OccupationSkill'));
                })

                aosIds.forEach(id => {
                    this.selected.push(this.occSkills.data.find(os => os.id == id && os.resource == 'AdminOccupationSkill'));
                })

                // On force la propagation
                this.onSelectedChange();
            })
        }

    },
    watch: {
        value(value) {
            this.selected = value.slice()
        },
        search(value) {
            this.handleSearch()
        },
        sector(value) {
            this.handleSectorChange(value)
        },
        occupation(value) {
            this.handleOccupationChange(value)
        },
        gridSector(value) {
            this.sector = value
        },
        filterByOnlyMine(value) {
            if (value) {
                this.occupation = null;
                this.selected = []
                this.fetchOccSkills(this.sector?.id);
            }
            else {
                this.selected = []
                this.occSkills.data = [];
                this.occupation = null;
                this.page = 1;
                this.fetchOccSkills(this.sector?.id);
            }
        }
    },
    computed: {

        hasOccupationSkills() {
            let value = !!(this.occSkills.data && this.occSkills.data.length);
            this.$emit("hasOccupationSkills", value);

            return value;
        },

        establishmentsServices() {
            if (this.isASuperAdmin(this.user) || (this.isAnAdmin(this.user) && this.user.establishments?.length == 0)) {
                return this.establishments.data.flatMap(e => e.services);
            } else if (this.user && this.user.establishments?.length) {
                return this.user.establishments.flatMap(e => e.services);
            }
            return [];
        },
        establishmentsServicesIds() {
            if (!this.establishments.loading) {
                return this.establishmentsServices.flatMap(s => s.id);
            }
            return [];
        },

        occSkillList() {
            if (!this.occSkills.data.length) return [];

            let servicesIds = this.establishmentsServicesIds;
            let items = this.occSkills.data.filter(item => {
                // Creation
                if (!this.selected?.length) {
                    if (this.filterByUserRelated) {
                        let jobs = item.jobs.filter(j => {
                            return servicesIds.includes(j.service_id);
                        });
                        if (jobs.length && this.filterBySector) {
                            if (this.service)
                                return item.sector_id == this.service.sector_id;
                            if (this.sector)
                                return item.sector_id == this.sector.id;
                        }
                        return !!jobs.length;
                    }
                    if (this.filterBySector) {
                        if (this.service)
                            return item.sector.id === this.service.sector_id;
                        if (this.sector)
                            return item.sector.id === this.sector.id;
                    }
                    return true;
                }

                // Edition
                if (this.selected?.length) {
                    if (this.selected.find(el => el.id === item.id)) {
                        return false;
                    }
                    if (this.filterByUserRelated) {
                        let jobs = item.jobs.filter(j => {
                            return servicesIds.includes(j.service_id);
                        });
                        if (jobs.length && this.filterBySector) {
                            if (this.service)
                                return item.sector_id == this.service.sector_id;
                            if (this.sector)
                                return item.sector_id == this.sector.id;
                        }
                        return !!jobs.length;
                    }
                    if (this.filterBySector) {
                        if (this.service)
                            return item.sector.id === this.service.sector_id;
                        if (this.sector)
                            return item.sector.id === this.sector.id;
                    }
                    return true;
                }
                return true;
            });

            return items;
        },

        /**
         * List of skills grouped by sector
         * Ordered by alphabetique order
         * @returns Array
         */
        occupationSkillsBySector() {
            let items = this.occSkillList;
            if (!items?.length) return {};

            items.sort((a, b) => {
                if (a.sector.title != b.sector.title) {
                    return a.sector.title > b.sector.title ? 1 : -1;
                } else {
                    return a.title > b.title ? 1 : -1;
                }
            });

            let occupationSkillsBySector = {};
            items.forEach(skill => {
                if (!occupationSkillsBySector[skill.sector.title]) {
                    occupationSkillsBySector[skill.sector.title] = [];
                }
                occupationSkillsBySector[skill.sector.title].push(skill);
            });

            return occupationSkillsBySector;
        }
    },
    methods: {
        handleSearch: _.debounce(function () {
            if (this.sector?.id) {
                this.occSkills.data = [];
                this.page = 1;
                this.fetchOccSkills(this.sector.id)
            }
            else if (this.filterByOnlyMine){
                this.occSkills.data = [];
                this.page = 1;
                this.fetchOccSkills()
            }
            else if (this.occupation){
                this.occSkills.data = [];
                this.page = 1;
                const aosIds = this.occupation?.admin_occupation_skills?.map(aos => aos.id)
                if (aosIds.length > 0) {
                    this.fetchOccSkills(null, null, aosIds);
                }
            }
            else {
                this.occSkills.data = [];
            }
        }, 500),

        /*handleSearch: _.debounce(function () {
            this.sector = null
            this.occSkills.data = [];
            this.page = 1;

            if (this.search.length >= 3) {
                this.fetchOccSkills()
            } else {
                this.occSkills.data = [];
            }
        }, 500),*/

        async handleScrollLoadMore() {
            
            this.page++
            if (this.page <= this.lastPage) {
                
                if (this.sector) {
                    await this.fetchOccSkills(this.sector?.id)
                } else if (this.occupation) {
                    const aosIds = this.occupation?.admin_occupation_skills.map(aos => aos.id)
                    await this.fetchOccSkills(null, null, aosIds);
                }

                return this.page < this.lastPage
            } else {
                return false
            }
        },

        handleSectorChange(sector) {
            
            // Reset de la liste car changement de filière
            this.occSkills.data = [];
            if (sector) this.occupation = null;
            this.page = 1;

            if (sector || this.filterByOnlyMine) {
                this.fetchOccSkills(sector?.id);
            }

        },

        handleOccupationChange(occupation) {
            
            // Reset de la liste car changement de filière
            this.occSkills.data = [];
            if (occupation) this.sector = null;
            this.page = 1;

            const aosIds = occupation?.admin_occupation_skills?.map(aos => aos.id)

            if (aosIds && aosIds.length > 0) {
                this.fetchOccSkills(null, null, aosIds);
            }
        },

        async fetchOccSkills(sectorId = null, osIds = null, aosIds = null) {
            this.occSkills.loading = true;

            let filter1, filter2 
            
            if (sectorId) {
                filter1 = filter2 = `sector_id|=|${sectorId}`
            } else if (osIds || aosIds) {
                filter1 = `id|IN|${Array.isArray(osIds) ? osIds.join(',') : ''}`
                filter2 = `id|IN|${Array.isArray(aosIds) ? aosIds.join(',') : ''}`
 
            } else if (!this.filterByOnlyMine) {
                this.occSkills.data = [];
                return;
            }

            const response1 = await loadOccupationSkills({
                filter: filter1, 
                include: ['sector', 'jobs', 'occupations'],
                search: this.search,
                page: this.page,
                perpage: 99
            })


            const response2 = this.filterByOnlyMine ?
                {
                    data: {}
                }
                : await loadAdminOccupationSkills({
                    filter: filter2,
                    include: ['sector', 'adminOccupations'],
                    search: this.search,
                    page: this.page,
                    perpage: 99
                })

            this.lastPage = response1.data.last_page
            if (!this.filterByOnlyMine) this.lastPage = Math.max(response1.data.last_page, response2.data.last_page)

            let occSkills = []
            if (!this.filterByOnlyMine) {
                occSkills = [
                    ...response1.data.data,
                    ...response2.data.data.map(item => {
                        item.title = `${item.title} (${item.type})`;
                        return item;
                    })
                ];
            }
            else {
                occSkills = [...response1.data.data];
            }

            this.occSkills.data = [...this.occSkills.data, ...occSkills];

            this.occSkills.loading = false;
        },

        async fetchEstablishments() {
            if (this.is_admin_interface) {
                return;
            }

            this.establishments.loading = true;

            return window.axios({
                method: 'get',
                url: '/api/referentiel/establishments',
                params: {perpage: 9999, include: ['services']},
            })
            .then(response => {
                this.establishments.data = response.data.data;
                this.establishments.loading = false;
            })
            .catch((err) => {
                console.log(err)
                this.notifyError(err, `Une erreur est survenue`)
            })
        },
        async fetchSectors() {
            this.sectors.loading = true;

            return loadSectors({ perpage: 9999, include:[] }).then((response) => {
                this.sectors.data = response.data.data;
                this.sectors.loading = false;
            })
        },
        async fetchAdminOccupations() {
            this.occupations.loading = true;

            return loadAdminOccupations({ 
                perpage: 9999, 
                include: ['admin_occupation_skills'] 
            }).then((response) => {
                this.occupations.data = response.data.data;
                this.occupations.loading = false;
            })
        }, 
        onSelectedChange() {
            let selected = this.selected.map(function(item, key) {
                item.order = key;
                return item;
            })
            console.log('Emit selection change', selected)
            this.$emit("input", selected);
        },
        redirect() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
.selector-container {
    min-height: 200px;
    &.empty {
        background-color: #f8f8f8;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        a {
            cursor: pointer;
        }
        > * {
            font-size: 1.1em;
        }
    }
    p.title {
        font-size: 1.05em;
    }
    .vs-col {
        padding: 0;
    }
    .scrollable_list {
        height: 250px;
        min-height: 250px;
        overflow-y: auto;
    }
}
</style>
